import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import Button from '../../../../components/Button.js';
import { Link } from 'react-router-dom';
import useFetch from '../../../../hooks/useFetch.js';
import { getUserProvider } from '../../../../../actions/auth.js';

import { getV2Competitions } from '../../../../../api/index.js';
import CompetitionDTO from '../../../../DTO/CompetitionDTO.js';


const GetCompetitions = () => {

    return <Box sx={{ textAlign : 'center'}}>
            <Competitions/>
    </Box>

}

const Competitions = () => {

    const provider = getUserProvider()
    const { data, isLoading, error, fetchData  } = useFetch(getV2Competitions, [provider]);

    const [competitions, setCompetitions] = useState()

    useEffect(() => {
        fetchData()
    }, [])

    useEffect(() => {
        if(!data)
            return

        const myDTOS = data.map(d => new CompetitionDTO(d))

        setCompetitions(myDTOS)

    }, [data])


   
    if (isLoading) return <div>Chargement...</div>;
    if (error) return <div>Erreur : {error.message}</div>;

   return (
        <div>
          {competitions && competitions.map(c => <Competition competition={c}/>)}
        </div>
      );
 
}

const Competition = ({competition}) => {

    return (
        <Card sx={{ width: '300px', display: 'inline-block', m: 3, p: 1 }}>
          <CardMedia image={undefined} title="Direct" />
          <CardContent>
            <Typography variant="subtitle1" style={{fontWeight:'bolder'}} >{competition.name}</Typography>
            <Typography variant="subtitle2">
             config : {competition.idNameConfig}
            </Typography>
          </CardContent>
          <Box style={{padding:'1em'}}>
            <Button  sx={{ m: 1 }} component={Link} to={"view/" + competition._id}>
                Editer la compétition
            </Button>
            </Box>
        </Card>
      );
}

export default GetCompetitions